import { ButtonGroup } from '@mui/material';
import { closeAside } from '@newStore/documentUI/documentUIState';
import { selectTypeNameSingle } from '@newStore/documentUI/nodeTypeConfigSelectors';
import { selectAsideHeaderTabVisible } from '@store/selectors/asideSelectors';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import AsideHeaderTabButton from './AsideHeaderButton'; // Import the new component

const metaButton = { value: 'metadata', label: 'Metadata' } as const;
const audienceButton = { value: 'audiences', label: 'Doelpubliek' } as const;
const webButton = { value: 'web', label: 'Web' } as const;

const AsideHeader: React.FC<Record<string, never>> = () => {
  const dispatch = useDispatch();

  const title = useTypedSelector(
    (state) =>
      (state.documentUI.currentEditingNode &&
        selectTypeNameSingle(state, state.documentUI.currentEditingNode)) ||
      '',
  );

  const isMetaVisible = useTypedSelector(
    (state) =>
      state.documentUI.currentEditingNode &&
      selectAsideHeaderTabVisible(state, state.documentUI.currentEditingNode, metaButton.value),
  );

  const isAudienceVisible = useTypedSelector(
    (state) =>
      state.documentUI.currentEditingNode &&
      selectAsideHeaderTabVisible(state, state.documentUI.currentEditingNode, audienceButton.value),
  );

  const isWebVisible = useTypedSelector(
    (state) =>
      state.documentUI.currentEditingNode &&
      selectAsideHeaderTabVisible(state, state.documentUI.currentEditingNode, webButton.value),
  );

  const close = () => {
    dispatch(closeAside());
  };

  return (
    <>
      <div className="navbar-controls-left">
        <div className="navbar-controls">
          <div className="btn-toolbar">
            <a className="btn btn-icon btn-default" onClick={close}>
              <span className="glyphicon glyphicon-arrow-left" />
              <span className="sr-only">Terug</span>
            </a>
            <div
              title={title}
              className="navbar-text navbar-text-big navbar-text-special-margin"
              style={{
                whiteSpace: 'nowrap',
                fontSize: '18px',
                marginBottom: 0,
                color: '#2c2c2c',
                fontWeight: 700,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '380px',
              }}
            >
              {title}
            </div>
          </div>
        </div>
      </div>
      <div className="navbar-controls-right">
        <div className="navbar-controls">
          <div className="btn-toolbar">
            <ButtonGroup size="large" color="primary">
              {isMetaVisible && (
                <AsideHeaderTabButton
                  key={metaButton.value}
                  value={metaButton.value}
                  label={metaButton.label}
                />
              )}
              {isAudienceVisible && (
                <AsideHeaderTabButton
                  key={audienceButton.value}
                  value={audienceButton.value}
                  label={audienceButton.label}
                />
              )}
              {isWebVisible && (
                <AsideHeaderTabButton
                  key={webButton.value}
                  value={webButton.value}
                  label={webButton.label}
                />
              )}
            </ButtonGroup>
          </div>
        </div>
      </div>
    </>
  );
};

AsideHeader.displayName = 'AsideHeader';
export default AsideHeader;
